import { render, staticRenderFns } from "./LearningUnitPriceInput.vue?vue&type=template&id=c5fc121c&"
import script from "./LearningUnitPriceInput.vue?vue&type=script&lang=js&"
export * from "./LearningUnitPriceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports